module.exports = __webpack_public_path__ + "static/img/cont40_03.80ea63c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_03.jpg
// module id = 97Ef
// module chunks = 0